import React from 'react';

export default function LiabilityDisclaimerPage() {
  return (
    <div className="app-shell legal-page">
      <div className="ambient ambient-left" />
      <div className="ambient ambient-right" />

      <header className="topbar legal-topbar">
        <a className="brand" href="/">
          <img className="brand-mark" src="/SROIK-LOGO.PNG" alt="Sroik" />
        </a>
        <div className="legal-topbar-actions">
          <a className="secondary-action" href="/login">Open workspace</a>
        </div>
      </header>

      <main className="page-view legal-content">
        <div className="page-header">
          <p className="feature-eyebrow">Legal</p>
          <h2>Liability Disclaimer</h2>
          <p className="page-subtitle">Effective date: April 1, 2026</p>
        </div>

        <article className="workspace-block legal-block">
          <h4>1. Zero-Liability Intent</h4>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, SROIK SHALL HAVE NO LIABILITY FOR ANY LOSS,
            DAMAGE, COST, OR CLAIM ARISING FROM OR RELATED TO USE OF THE SERVICE, INCLUDING DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, EXEMPLARY, CONSEQUENTIAL, OR PUNITIVE DAMAGES.
          </p>

          <h4>2. No Operational Warranty</h4>
          <p>
            Sroik provides recommendations and analytics support. You retain full responsibility for deciding,
            validating, and executing infrastructure and financial changes.
          </p>

          <h4>3. No Financial or Legal Advice</h4>
          <p>
            Platform outputs are informational and do not constitute financial, accounting, tax, legal, or regulatory
            advice. You should consult qualified professionals before acting on recommendations.
          </p>

          <h4>4. Third-Party Services</h4>
          <p>
            Sroik is not liable for failures, outages, billing anomalies, API changes, or policy decisions made by
            cloud providers or any external service provider.
          </p>

          <h4>5. Security and Access Configuration</h4>
          <p>
            You are solely responsible for access configuration, IAM policy approval, credential lifecycle,
            compliance posture, and any customer-environment changes.
          </p>

          <h4>6. Data and Availability</h4>
          <p>
            Sroik does not guarantee uninterrupted availability, error-free operation, or complete accuracy of all
            data sources at all times.
          </p>

          <h4>7. Liability Cap and Exclusions</h4>
          <p>
            If liability cannot be fully excluded by law, it will be limited to the lowest amount permitted by law
            and, where applicable, by the controlling commercial agreement.
          </p>

          <h4>8. Basis of Bargain</h4>
          <p>
            You acknowledge that these limitations are a material basis for use of the service and pricing.
          </p>

          <h4>9. Regional Applicability</h4>
          <p>
            Some jurisdictions may not allow certain exclusions. In those jurisdictions, exclusions apply only to
            the extent legally permitted.
          </p>

          <h4>10. Contact</h4>
          <p>
            Liability disclaimer questions: <a href="mailto:support@sroik.com">support@sroik.com</a>
          </p>
        </article>
      </main>
    </div>
  );
}
